export class Topic {
  discourseTopicId: number;
  discourseCategoryId: number;
  polymorphicId: number;
  polymorphicType: string;
  title: string;
  url: string = '';
}
